/* eslint-disable import/no-anonymous-default-export */

let parameterStock = {
  name: "Parameter Saham",
  slug: "parameterStock",
  visible: true,
  crud: true,
  singularName: "parameterStock",
  endpoint: "/v1/bo/emitenData",
  updateLabel: "parameterStock",
  access: ["superadmin"],
  delete: false,
  exportToCsv: false,
  noNeedSearch: true,
  noNeedRefresh: true,
  parameter: true,
  upload_data: true,
  add: false,
  update: false,
  dataRefFilters: false,
  edit: false,
  actions: [],
  fields: [
    {
      label:"Period",
      name:"period",
      type:"text",
      resource_label:(data)=>{
        return data.period;
      }
    },{
      label:"Value",
      name:"value",
      type:"text",
      resource_label:(data)=>{
        return data.value;
      }
    }
  ],
};


export default [
  parameterStock,
]